import type {
  QueryFunctionContext,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import groq from 'groq';
import { SLUG } from 'lib/queries';
import { client } from 'lib/sanity';
import type { SiteCategory } from 'types/common/SiteCategory';

export type ProductListingQueryKey = [string, string];

type PlpPage = {
  label: string;
  slug: string;
};

type ProductListingPagesQuery = UseQueryResult & {
  data: PlpPage[];
};

export const PRODUCT_LISTING_PAGES_KEY = 'productListingPages';

export const fetchProductListingPages = async ({
  queryKey,
}: QueryFunctionContext<ProductListingQueryKey>) => {
  const query = groq`
    *[_type in ["timeline_plp"] && !(_id in path('drafts.**')) && category == $category] {
      ${SLUG},
      label,
    }
  `;

  return client.fetch<PlpPage[]>(query, {
    category: queryKey[1],
  });
};

export const useProductListingPages = (siteCategory: SiteCategory) =>
  useQuery({
    queryKey: [PRODUCT_LISTING_PAGES_KEY, siteCategory],
    queryFn: fetchProductListingPages,
  }) as ProductListingPagesQuery;
